<script lang="ts" setup>
import imageMasterCard from '@/assets/images/footer/footer-master-card.webp'
import imageMir from '@/assets/images/footer/footer-mir.webp'
import imageVisaWhite from '@/assets/images/footer/footer-visa-white.webp'
</script>

<template>
  <div class="copyright__card-list" data-test-id="footer-card-list">
    <nuxt-img
      class="copyright__image"
      :src="imageVisaWhite"
      alt="Visa"
      data-test-id="payment-card"
    />
    <nuxt-img
      class="copyright__image"
      :src="imageMasterCard"
      alt="MasterCard"
      data-test-id="payment-card"
    />
    <nuxt-img
      class="copyright__image"
      :src="imageMir"
      alt="Mir"
      data-test-id="payment-card"
    />
  </div>
</template>

<style scoped lang="scss">
.copyright__card-list {
  display: flex;
  gap: 0 20px;
  align-items: center;
}

.copyright__image {
  height: 20px;
}
</style>
